import { Dayjs } from 'dayjs';

export enum LifecycleType {
  ONBOARD = 'onboard',
  EXIT = 'exit',
}

export enum LifecycleLabel {
  ONBOARD = 'Onboard',
  EXIT = 'Exit',
}

export type PulseLifecycleProjectReceived = {
  type: LifecycleType;
  createdAt: Dayjs;
};

export type PulseLifecycleProjectReceivedEntry = {
  type: LifecycleType;
  createdAt: string;
};
